<div mat-dialog-content>
  <mat-stepper #stepper>
    <mat-step [stepControl]="nameGroup">
      <form [formGroup]="nameGroup">
        <br>
        <ng-template matStepLabel>Org Name</ng-template>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput [formControl]="nameControl" required>
        </mat-form-field>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="typeGroup">
      <form [formGroup]="typeGroup">
        <br>
        <ng-template matStepLabel>Booth Size</ng-template>
        <mat-form-field>
          <mat-label>Size</mat-label>
          <mat-select [formControl]="typeControl">
            <mat-option *ngFor="let type of types" [value]="type">
              {{type}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="ownerGroup">
      <form [formGroup]="ownerGroup">
        <br>
        <ng-template matStepLabel>Select Owner</ng-template>
        <app-player-search (selectedPlayerEvent)="changeOwner($event)">

        </app-player-search>
        <div>
          <button (click)="save()" mat-raised-button color="primary">Save</button>
        </div>
      </form>
    </mat-step>
  </mat-stepper>
</div>
